const BLOCK_NUMBER = "0xFB0A000000000000000000000000000000000000";
const L1_BLOCK_NUMBER = "0xFBAA000000000000000000000000000000000000";
const BLOCK_TIMESTAMP = "0xFB0B000000000000000000000000000000000000";
const GAS_PRICE = "0xFB0C000000000000000000000000000000000000";
const MINER_ADDRESS = "0xFA0A000000000000000000000000000000000000";
const ORIGIN_ADDRESS = "0xFA0B000000000000000000000000000000000000";
const INVESTOR_ADDRESS = "0xFA0C000000000000000000000000000000000000";
const ACTIVATOR_ADDRESS = "0xFA0D000000000000000000000000000000000000";
const ENGINE_ADDRESS = "0xFA0E000000000000000000000000000000000000";
const CHAIN_ID = "0xFB0E000000000000000000000000000000000000";
const FLOW_HASH = "0xFB0D000000000000000000000000000000000000";
const RANDOM_NUMBER = "0xFB08000000000000000000000000000000000000";
const FCT_MAX_GAS_PRICE = "0xFB09000000000000000000000000000000000000";
const FCT_MAX_REPEATS = "0xFB0FA000000000000000000000000000000000000";
const FCT_REPEATS_LEFT = "0xFB0FB000000000000000000000000000000000000";
// const BLOCK_HASH = "0xFF00000000000000000000000000000000000000";
// Tal Asa
//   6:39 PM
// uint256 constant VAR_FCT_MAX_REPEATS = 0x00FB0FA00000000000000000000000000000000000;
// uint256 constant VARX_FCT_MAX_REPEATS = 0xFB0FA00000000000000000000000000000000000000000000000000000000000;
// uint256 constant VAR_FCT_REPEATS_LEFT = 0x00FB0FB00000000000000000000000000000000000;
// uint256 constant VARX_FCT_REPEATS_LEFT = 0xFB0FB00000000000000000000000000000000000000000000000000000000000;
// uint256 constant VAR_FCT_MAX_GAS_PRICE = 0x00FB09000000000000000000000000000000000000;
// uint256 constant VARX_FCT_MAX_GAS_PRICE = 0xFB09000000000000000000000000000000000000000000000000000000000000;
// uint256 constant VAR_ADDRESS_ORIGIN = 0x00FA0B000000000000000000000000000000000000; // tx.origin
export const globalVariables = {
    blockNumber: BLOCK_NUMBER,
    blockTimestamp: BLOCK_TIMESTAMP,
    chainId: CHAIN_ID,
    gasPrice: GAS_PRICE,
    minerAddress: MINER_ADDRESS,
    originAddress: ORIGIN_ADDRESS,
    investorAddress: INVESTOR_ADDRESS,
    activatorAddress: ACTIVATOR_ADDRESS,
    engineAddress: ENGINE_ADDRESS,
    flowHash: FLOW_HASH,
    randomNumber: RANDOM_NUMBER,
    fctMaxGasPrice: FCT_MAX_GAS_PRICE,
    l1BlockNumber: L1_BLOCK_NUMBER,
    fctMaxRepeats: FCT_MAX_REPEATS,
    fctRepeatsLeft: FCT_REPEATS_LEFT,
};
export const globalVariablesBytes = {
    blockNumber: BLOCK_NUMBER.padEnd(66, "0"),
    blockTimestamp: BLOCK_TIMESTAMP.padEnd(66, "0"),
    chainId: CHAIN_ID.padEnd(66, "0"),
    gasPrice: GAS_PRICE.padEnd(66, "0"),
    flowHash: FLOW_HASH.padEnd(66, "0"),
    randomNumber: RANDOM_NUMBER.padEnd(66, "0"),
    fctMaxGasPrice: FCT_MAX_GAS_PRICE.padEnd(66, "0"),
    l1BlockNumber: L1_BLOCK_NUMBER.padEnd(66, "0"),
    fctMaxRepeats: FCT_MAX_REPEATS.padEnd(66, "0"),
    fctRepeatsLeft: FCT_REPEATS_LEFT.padEnd(66, "0"),
};
//# sourceMappingURL=globalVariables.js.map